<template>
    <div class="maxContainer tradingIdeas">  
		<div class="mainTitle text-center my-3">
			<h3>{{$t('tradingIdeas')}}</h3>
		</div>
		<div class="row">
		  <div class="col-4">
			<div class="card"> 
			  
			  <div class="card-body"> 
				<h5 class="card-title">{{$t('ChannelDownIdentified')}} 5/19 01:15.</h5>
				<img src="../../../../static/fxView/images/tradeideas1.png" class="mb-3 card-img-top" alt="...">
				<p class="card-text mb-3"> {{$t('ThisPatternProcess')}}</p>
				<div class="view-likes-block d-flex align-items-center justify-content-between">
				  <div class="currency-info d-flex align-items-center">
					<div class="currency mr-3">
					  GBPDKK, 0D
					</div>
					<span class="short">                                                           
					  <span class="badge badge-pill badge-success">{{$t('Short')}}</span>
					</span>
				  </div>
				  <div class="colRight d-flex align-items-center">
					<div class="views d-flex align-items-center"><feather type="eye" class="mr-2"></feather> 0</div>
					<div class="date d-flex align-items-center"><feather type="calendar" class="mr-2"></feather> 19 {{$t('May')}}</div>
				  </div>
				</div> 
			  </div>
			</div>
		  </div>
		  <div class="col-4">
			<div class="card"> 
			   
			  <div class="card-body"> 
				<h5 class="card-title">{{$t('ChannelDownIdentified')}} 5/19 01:15.</h5>
				<img src="../../../../static/fxView/images/tradeideas1.png" class="mb-3 card-img-top" alt="...">
				<p class="card-text mb-3"> {{$t('ThisPatternProcess')}}</p>
				<div class="view-likes-block d-flex align-items-center justify-content-between">
				  <div class="currency-info d-flex align-items-center">
					<div class="currency mr-3">
					  GBPDKK, 0D
					</div>
					<span class="short">                                                           
					  <span class="badge badge-pill badge-success">{{$t('Short')}}</span>
					</span>
				  </div>
				  <div class="colRight d-flex align-items-center">
					<div class="views d-flex align-items-center"><feather type="eye" class="mr-2"></feather> 0</div>
					<div class="date d-flex align-items-center"><feather type="calendar" class="mr-2"></feather> 19 {{$t('May')}}</div>
				  </div>
				</div> 
			  </div>
			</div>
		  </div>
		  <div class="col-4">
			<div class="card"> 
			  
			  <div class="card-body"> 
				<h5 class="card-title">{{$t('ChannelDownIdentified')}} 5/19 01:15.</h5>
				<img src="../../../../static/fxView/images/tradeideas1.png" class="mb-3 card-img-top" alt="...">
				<p class="card-text mb-3"> {{$t('ThisPatternProcess')}}</p>
				<div class="view-likes-block d-flex align-items-center justify-content-between">
				  <div class="currency-info d-flex align-items-center">
					<div class="currency mr-3">
					  GBPDKK, 0D
					</div>
					<span class="short">                                                           
					  <span class="badge badge-pill badge-success">{{$t('Short')}}</span>
					</span>
				  </div>
				  <div class="colRight d-flex align-items-center">
					<div class="views d-flex align-items-center"><feather type="eye" class="mr-2"></feather> 0</div>
					<div class="date d-flex align-items-center"><feather type="calendar" class="mr-2"></feather> 19 {{$t('May')}}</div>
				  </div>
				</div> 
			  </div>
			</div>
		  </div>
		  <div class="col-4">
			<div class="card"> 
			  
			  <div class="card-body"> 
				<h5 class="card-title">{{$t('ChannelDownIdentified')}} 5/19 01:15.</h5>
				<img src="../../../../static/fxView/images/tradeideas1.png" class="mb-3 card-img-top" alt="...">
				<p class="card-text mb-3"> {{$t('ThisPatternProcess')}}</p>
				<div class="view-likes-block d-flex align-items-center justify-content-between">
				  <div class="currency-info d-flex align-items-center">
					<div class="currency mr-3">
					  GBPDKK, 0D
					</div>
					<span class="short">                                                           
					  <span class="badge badge-pill badge-success">{{$t('Short')}}</span>
					</span>
				  </div>
				  <div class="colRight d-flex align-items-center">
					<div class="views d-flex align-items-center"><feather type="eye" class="mr-2"></feather> 0</div>
					<div class="date d-flex align-items-center"><feather type="calendar" class="mr-2"></feather> 19 {{$t('May')}}</div>
				  </div>
				</div> 
			  </div>
			</div>
		  </div>
		  <div class="col-4">
			<div class="card"> 
			  
			  <div class="card-body"> 
				<h5 class="card-title">{{$t('ChannelDownIdentified')}} 5/19 01:15.</h5>
				<img src="../../../../static/fxView/images/tradeideas1.png" class="mb-3 card-img-top" alt="...">
				<p class="card-text mb-3"> {{$t('ThisPatternProcess')}}</p>
				<div class="view-likes-block d-flex align-items-center justify-content-between">
				  <div class="currency-info d-flex align-items-center">
					<div class="currency mr-3">
					  GBPDKK, 0D
					</div>
					<span class="short">                                                           
					  <span class="badge badge-pill badge-success">{{$t('Short')}}</span>
					</span>
				  </div>
				  <div class="colRight d-flex align-items-center">
					<div class="views d-flex align-items-center"><feather type="eye" class="mr-2"></feather> 0</div>
					<div class="date d-flex align-items-center"><feather type="calendar" class="mr-2"></feather> 19 {{$t('May')}}</div>
				  </div>
				</div> 
			  </div>
			</div>
		  </div>
		  <div class="col-4">
			<div class="card"> 
			   
			  <div class="card-body"> 
				<h5 class="card-title">{{$t('ChannelDownIdentified')}} 5/19 01:15.</h5>
				<img src="../../../../static/fxView/images/tradeideas1.png" class="mb-3 card-img-top" alt="...">
				<p class="card-text mb-3"> {{$t('ThisPatternProcess')}}</p>
				<div class="view-likes-block d-flex align-items-center justify-content-between">
				  <div class="currency-info d-flex align-items-center">
					<div class="currency mr-3">
					  GBPDKK, 0D
					</div>
					<span class="short">                                                           
					  <span class="badge badge-pill badge-success">{{$t('Short')}}</span>
					</span>
				  </div>
				  <div class="colRight d-flex align-items-center">
					<div class="views d-flex align-items-center"><feather type="eye" class="mr-2"></feather> 0</div>
					<div class="date d-flex align-items-center"><feather type="calendar" class="mr-2"></feather> 19 {{$t('May')}}</div>
				  </div>
				</div> 
			  </div>
			</div>
		  </div>
		</div>
		<div class="text-center">
		  <a href="https://portfolios.com/" class="prism_btn btn_sm mb-3" target="_blank">{{$t('SeeMore')}}</a>
		  <p class="mb-5">{{$t('Poweredby')}} <a href="https://portfolios.com/" target="_blank">{{$t('PortfoliosCom')}}</a></p>
		</div>
    </div>
</template>
<script> 
  import { fxViewMixins } from '@/plugins/fxView'
    export default {
      name: 'subscription',
      mixins: [fxViewMixins],
      data() {
        return {
           
        }
      },
      components:{
         
      },
      methods:{
         
      },
      computed:{
         
      }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/market.vue